import React from "react";
import { Device } from "../../../types/Device";
import { CountType, DirectionalCount } from "../../../types/Count";
import { BaseDeviceCard } from "./base-device-card";
import { CardContent } from "@mui/material";
import { DeviceCountTable } from "./count-table";

interface UnidirectionalDeviceCardProps {
    device: Device;
    count: DirectionalCount;
    videoId?: string;
}

export const UnidirectionalDeviceCard: React.FC<
    UnidirectionalDeviceCardProps
> = ({ device, count, videoId }) => {
    const renderContent = () => {
        if (!count) return null;
        const [directionKey] = Object.keys(count) as [keyof DirectionalCount];
        const value = count[directionKey][CountType.Predicted]!;
        return (
            <CardContent
                sx={{
                    minHeight: 150,
                }}
            >
                <DeviceCountTable
                    count={{
                        Count: {
                            Predicted: value,
                            UpperBound: null,
                            LowerBound: null,
                            Adjusted: null,
                        },
                    }}
                />
            </CardContent>
        );
    };

    return (
        <BaseDeviceCard
            device={device}
            count={count}
            videoId={videoId}
            renderContent={renderContent}
            getDeviceType={() => "unidirectional"}
        />
    );
};
